import { useTranslations } from 'next-intl';
import { ChangeEvent } from 'react';
import { InvoiceForm } from '@/components/commons/InvoiceForm';
import Checkbox from '../../../../components/design-system/Checkbox';
import { InvoiceInfo } from '@/components/commons/InvoiceInfo';
import { BillingData } from '@winelivery-org/wl-client-sdk-js';

interface Props {
  invoiceEnabled: boolean;
  invoiceFormVisible: boolean;
  invoice: BillingData;
  invoiceCheckboxChanged: (event: ChangeEvent<HTMLInputElement>) => void;
  setIsInvoiceFormVisible: () => void;
  onSubmitted: (invoice: BillingData) => void;
}

const InvoiceSection = ({
  invoiceEnabled,
  invoiceCheckboxChanged,
  invoiceFormVisible,
  onSubmitted,
  setIsInvoiceFormVisible,
  invoice,
}: Props) => {
  const t = useTranslations('common');

  const renderInvoiceEnabledCheckbox = () => {
    return (
      <div className="tw-mt-4">
        <Checkbox
          label={t('InvoiceSection.yes-need-invoice')}
          onChange={invoiceCheckboxChanged}
          checked={invoiceEnabled}
          id="bill" />
      </div>
    );
  };

  if (!invoiceEnabled) { return renderInvoiceEnabledCheckbox(); }

  return (
    <div>
      {renderInvoiceEnabledCheckbox()}

      <div className="tw-mt-2">
        <a onClick={setIsInvoiceFormVisible}>
          {invoiceFormVisible
            ? t('InvoiceSection.cancel')
            : t('InvoiceSection.change')}
        </a>
      </div>
      {invoice && !invoiceFormVisible && (
        <div className="tw-mt-4">
          <InvoiceInfo
            invoice={invoice}
            setIsInvoiceFormVisible={setIsInvoiceFormVisible}
          />
        </div>
      )}
      {invoiceFormVisible && (
        <div className="tw-mt-4">
          <InvoiceForm
            invoice={invoice}
            onSubmitted={onSubmitted}
          />
        </div>
      )}
    </div>
  );
};

export default InvoiceSection;
